document.addEventListener("DOMContentLoaded", function(){

    var swiperabout = new Swiper(".aboutus__v2--imagesslider", {
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: {
          el: ".swiper-scrollbar.aboutus",
           draggable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next.aboutus",
          prevEl: ".swiper-button-prev.aboutus",
        },
      });
      }); 